export default function (a, b) {
  if (!b) b = [];
  var n = a ? Math.min(b.length, a.length) : 0,
      c = b.slice(),
      i;
  return function (t) {
    for (i = 0; i < n; ++i) c[i] = a[i] * (1 - t) + b[i] * t;

    return c;
  };
}
export function isNumberArray(x) {
  return ArrayBuffer.isView(x) && !(x instanceof DataView);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-transition/node_modules/d3-interpolate/src/numberArray.js
// module id = 438
// module chunks = 0